import React from 'react';
import cx from 'classnames';

export type LinkifyProps = {
  className?: string;
  text: string;
};

export default function Linkify({ className, text }: LinkifyProps) {
  return (
    <div
      className={cx(className, 'whitespace-pre-line')}
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
  );
}
